export default "__VITE_ASSET__BCwqxDVt__"